import tw from 'twin.macro';

type QuestionDetailsProps = {
  number: number;
  title: string;
};

const QuestionDetails: React.FC<QuestionDetailsProps> = (props) => {
  const { number, title } = props;
  return (
    <div tw="flex flex-col gap-4 items-start sm:flex-row sm:gap-6 sm:items-center">
      <p tw="whitespace-nowrap rounded-full border-2 px-4 py-1 font-medium text-sm">
        {number === 0 ? 'ตัวอย่างคำถาม' : `คำถามข้อที่ ${number}`}
      </p>
      <h5 tw="text-lg md:text-2xl pl-[5px] md:pl-0">{title}</h5>
    </div>
  );
};

export default QuestionDetails;
